import { defineRouting } from "next-intl/routing";
import { locales } from "@/lib/shared/constants";

/** IANA zone for next-intl (required to avoid ENVIRONMENT_FALLBACK / hydration mismatches). */
export const defaultTimeZone = "UTC";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: locales,

  // Used when no locale matches
  defaultLocale: "en",

  // Page metadata owns hreflang so untranslated product locales can be left out.
  alternateLinks: false,
});
